import type { ReactNode } from "react";

export function UseCaseCard({
  icon,
  title,
  body,
  href,
}: {
  icon: ReactNode;
  title: string;
  body: string;
  href: string;
}) {
  return (
    <a
      href={href}
      className="flex h-full flex-col rounded-2xl border border-line bg-white p-6 no-underline shadow-sm transition hover:border-brand-200 hover:bg-brand-50/40"
    >
      <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-xl bg-brand-50 text-brand-700">
        {icon}
      </div>
      <h3 className="text-xl font-semibold text-ink">{title}</h3>
      <p className="mt-2 max-w-[65ch] text-base leading-7 text-muted">{body}</p>
    </a>
  );
}
